import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Heading,
  VStack,
  VStackProps,
  Text,
} from "@wootingkb/component-library";
import { ReactNode } from "react";
import RegionawareLink, { ReplaceableURL } from "./RegionawareLink";

interface CIProps {
  imgSrc: string;
  href: string;
  title: string | number;
  labels?: string[];
}

interface CICProps {
  title: string;
  children: ReactNode[];
}

export function CardItem({
  imgSrc,
  href,
  title,
}: CIProps & { href: ReplaceableURL }) {
  return (
    <RegionawareLink
      href={href}
      external
      hideExternalIcon
      className="block h-full"
    >
      <Card className="flex h-full flex-col gap-0 p-0">
        <CardHeader className="relative h-[120px] shrink-0 overflow-hidden md:h-[145px]">
          <img src={imgSrc} alt="" className="h-full w-full object-cover" />
        </CardHeader>
        <CardContent className="flex flex-1 p-6">
          <Text weight="semibold">{title}</Text>
        </CardContent>
      </Card>
    </RegionawareLink>
  );
}

export function CardItemContainer({
  title,
  children,
  ...rest
}: CICProps & VStackProps) {
  return (
    <VStack className="mt-10 gap-4" {...rest}>
      <Heading as="h3" size="h4" weight="bold">
        {title}
      </Heading>
      <Grid className="grid auto-rows-fr grid-cols-1 items-stretch gap-4 md:grid-cols-2">
        {children}
      </Grid>
    </VStack>
  );
}
